export default () => ({
  speciality: {
    attachment: {
      content: null,
      mime: null
    },
    speciality_id: null,
    rqe: null
  },
  includes: ['professional']
})



// WEBPACK FOOTER //
// ./src/app/employee/record/specialities/form/resources/data.js